import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IApiResult } from '../shared/models/api-result';
import { ApiUrlProvider } from './api-url.provider';
import { IOpenProjectViewModel } from '../shared/models/open-project-view-model';
import { IOpenProjectExcelExportModel } from '../projects/models/open-project-excel-export-model';


@Injectable({
  providedIn: 'root'
})
export class OpenProjectService {
  constructor(private http: HttpClient, private apiUrlProvider: ApiUrlProvider) { }
  
  getAll(): Observable<IApiResult<IOpenProjectViewModel[]>>{
    return this.http.get<IApiResult<IOpenProjectViewModel[]>>(`${this.apiUrlProvider.url}/OpenProject`);
  }

  add(projectIds: number[]): Observable<IApiResult<boolean>>{
    return this.http.post<IApiResult<boolean>>(`${this.apiUrlProvider.url}/OpenProject/add`, projectIds);
  }

  delete(openProject: IOpenProjectViewModel): Observable<IApiResult<string>>{
    return this.http.post<IApiResult<string>>(`${this.apiUrlProvider.url}/OpenProject/${openProject.projectId}/delete`, openProject);
  }

  reorder(openProjects: IOpenProjectViewModel[]): Observable<IApiResult<string>> {
    const payload = openProjects.map(p => ({
      projectId: p.projectId,
      priorityNo: p.priorityNo
    }));

    console.log('Reordering open projects:', payload);
    return this.http.post<IApiResult<string>>(`${this.apiUrlProvider.url}/OpenProject/reorder`, payload);
  }

  exportOpenProjects(openProjectExcelExportModel: IOpenProjectExcelExportModel, whenDone: any){
    let url = `${this.apiUrlProvider.url}/openproject/export`;

    return this.http
      .post(url, openProjectExcelExportModel, {responseType: 'blob'})
      .subscribe(res => {
        let objectUrl = window.URL.createObjectURL(res);
        let imageAnchor: HTMLAnchorElement = document.createElement("a");
        imageAnchor.href = objectUrl;
        imageAnchor.target = "_blank";
        imageAnchor.download = `OpenProjects.xlsx`;
        imageAnchor.click();
        window.URL.revokeObjectURL(objectUrl);
      }, _ => {})
      .add(()=>{
        if (whenDone){
          whenDone();
        }
      });
  }  
}
